module.exports = __webpack_public_path__ + "static/media/create.6ac044c5.png";